import React, { useState, useEffect } from "react";
import useHttp from "../../../../hooks/use-http";
import { toast } from "react-toastify";

const OrganizationWiseDashboardAllocationForm = (props) => {
  const [orgId, setOrgId] = useState("");
  const [orgData, setOrgData] = useState([]);
  const [moduleServicesData, setModuleServicesData] = useState();
  const [data, setData] = useState([]);
  const [moduleList, setModuleList] = useState([]);
  const [selectedModule, setSelectedModule] = useState("");
  const [serviceList, setServiceList] = useState([]);
  const [selectedService, setSelectedService] = useState("");
  const [serviceId, setServiceId] = useState("");
  const [filterNames, setFilterNames] = useState([]);
  const [allocatedCharts, setAllocatedCharts] = useState([]);

  const { sendRequest: getOrg } = useHttp();
  const { sendRequest: getMenuServices } = useHttp();
  const { sendRequest: getFilterNames } = useHttp();
  const { sendRequest: getAllocatedCharts } = useHttp();

  const orgDetails = () => {
    getOrg(
      {
        url: `/api/organisation/`,
      },
      (res) => {
        if (res) {
          setOrgData(res);
        }
      }
    );
  };

  useEffect(() => {
    getMenuServices(
      {
        url: `/api/menuServiceRoleAllocation/?userId=${localStorage.getItem(
          "id"
        )}`,
      },
      (res) => {
        if (res?.output) {
          setModuleList(res.output);
        }
      }
    );
  }, [getMenuServices]);

  const handleModuleChange = (e) => {
    const moduleId = e.target.value;
    setSelectedModule(moduleId);
    setSelectedService("");

    const selectedModuleObj = moduleList.find(
      (m) => m.moduleId === parseInt(moduleId)
    );
    if (!selectedModuleObj) return;

    const useCase = moduleToUseCase[selectedModuleObj.title] || "";
    const analyticsService = selectedModuleObj.menuItemList.find(
      (item) => item.menuTittle === "Analytics"
    );

    const serviceIdValue = analyticsService?.serviceSubId || "";
    setServiceId(serviceIdValue);
    setServiceList(analyticsService?.subItemList || []);

    loadFilterNames(useCase);
    loadAllocatedCharts(useCase, serviceIdValue);
  };

  useEffect(() => {
    orgDetails();
  }, [getOrg]);

  const handleOrgChange = (e) => {
    const id = e.target.value;
    setOrgId(id);
  };

  useEffect(() => {
    if (orgId) {
      serviceAllData(orgId);
    } else {
      setModuleServicesData("");
    }
  }, [orgId]);

  const { sendRequest: getServiceAllData } = useHttp();

  const serviceAllData = (orgId) => {
    getServiceAllData(
      {
        url: `/api/dashboardFilterNames/?orgId=${orgId}`,
      },
      (data) => {
        setModuleServicesData(data);
        setData(data);
      }
    );
  };

  useEffect(() => {
    serviceAllData();
  }, [getServiceAllData]);

  const { sendRequest: postOrgPermissions } = useHttp();

  const submitHandler = (e) => {
    e.preventDefault();

    const moduleObj = moduleList.find(
      (m) => m.moduleId === parseInt(selectedModule)
    );
    const useCase = moduleObj ? moduleToUseCase[moduleObj.title] : "";

    const payload = filterNames.map((chartName) => ({
      chartName: chartName,
      useCase: useCase,
      orgId: orgId,
      serviceId: serviceId,
      status: checkedState[chartName] ? 1 : 0,
    }));

    postOrgPermissions(
      {
        url: "/api/saveDashboardAllocation/",
        method: "POST",
        body: payload,
      },
      () => {
        toast.success("Dashboard Permissions Updated Successfully");
        props.addForm(false);
      }
    );
  };

  const initialChecked = (data || []).reduce((acc, item) => {
    acc[item.serviceChartAllocationId] = !!item.status;
    return acc;
  }, {});

  const [checkedState, setCheckedState] = useState(initialChecked);

  const moduleToUseCase = {
    "Procurement Console": "Procurement",
    "Sales Console": "sales",
    "Contract Console": "contract",
    "Warehouse Console": "warehouse",
    "Finance Console": "finance",
    "Agri Promoter": "Agri Promoter",
    "Tomato Joe": "TJoe",
    "Nursery": "nursery",
  };

  // load chart names by useCase (and orgId if you pass it)
  const loadFilterNames = (useCaseParam) => {
    if (!orgId || !useCaseParam) return;
    getFilterNames(
      {
        url: `/api/dashboardFilterNames/?orgId=${orgId}&useCase=${encodeURIComponent(
          useCaseParam
        )}`,
      },
      (res) => setFilterNames(Array.isArray(res) ? res : [])
    );
  };

  const loadAllocatedCharts = (useCaseParam, serviceIdParam) => {
    if (!orgId || !useCaseParam || !serviceIdParam) return;

    getAllocatedCharts(
      {
        url: `/api/dashboards/?orgId=${orgId}&useCase=${encodeURIComponent(
          useCaseParam
        )}&serviceId=${serviceIdParam}`,
      },
      (res) => {
        setAllocatedCharts(Array.isArray(res) ? res : []);
      }
    );
  };

  useEffect(() => {
  if (allocatedCharts.length === 0) return;

  setCheckedState((prev) => {
    const newState = { ...prev };
    allocatedCharts.forEach((item) => {
      // only pre-fill checkboxes once (when they were not manually changed yet)
      if (newState[item.chartName] === undefined) {
        newState[item.chartName] = item.status === 1;
      }
    });
    return newState;
  });
}, [allocatedCharts]);


  return (
    <>
      <div className="content-wrapper">
        <section className="content">
          <div className="container-fluid">
            <div className="card card-default">
              <form onSubmit={submitHandler}>
                <div className="card-header">
                  <h3 className="card-title">
                    Organization Wise Dashboard Allocation Form
                  </h3>
                  <div className="card-tools">
                    <button
                      type="button"
                      className="btn btn-tool"
                      data-card-widget="remove"
                      onClick={() => props.addForm(false)}
                    >
                      <i className="fas fa-times" />
                    </button>
                  </div>
                </div>

                <div className="card-body">
                  <div className="row">
                    <div className="col-md-1"></div>
                    <div className="col-md-3">
                      <div className="form-group">
                        <label>Organization Name</label>
                        <select
                          className="form-control"
                          value={orgId}
                          onChange={(e) => handleOrgChange(e)}
                          required
                        >
                          <option value="">Select</option>
                          {orgData &&
                            orgData.map((x) => (
                              <option key={x.orgId} value={x.orgId}>
                                {x.orgName}
                              </option>
                            ))}{" "}
                        </select>
                      </div>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-md-1"></div>

                    <div className="col-md-3">
                      <div className="form-group">
                        <label style={{ fontWeight: "500" }}>Module Name</label>
                        <select
                          className="form-control"
                          value={selectedModule}
                          onChange={handleModuleChange}
                          required
                        >
                          <option value="">Select Module</option>
                          {moduleList
                            .filter((m) =>
                              [
                                "Procurement Console",
                                "Sales Console",
                                "Contract Console",
                                "Warehouse Console",
                                "Finance Console",
                                "Agri Promoter",
                                "Nursery",
                              ].includes(m.title)
                            )
                            .map((m) => (
                              <option key={m.moduleId} value={m.moduleId}>
                                {m.title.replace(" Console", "")}
                              </option>
                            ))}
                        </select>
                      </div>
                    </div>

                    <div className="col-md-3">
                      <div className="form-group">
                        <label style={{ fontWeight: "500" }}>
                          Service Name
                        </label>
                        <select
                          className="form-control"
                          value={selectedService}
                          onChange={(e) => {
                            const service = e.target.value;
                            setSelectedService(service);

                            // Fetch dashboard list for selected service
                            if (orgId && selectedModule) {
                              const selectedModuleObj = moduleList.find(
                                (m) => m.moduleId === parseInt(selectedModule)
                              );
                              const useCase =
                                moduleToUseCase[selectedModuleObj.title] || "";

                              getServiceAllData(
                                {
                                  url: `/api/dashboardFilterNames/?orgId=${orgId}&useCase=${encodeURIComponent(
                                    useCase
                                  )}`,
                                },
                                (res) => {
                                  setData(res || []);
                                }
                              );
                            }
                          }}
                        >
                          <option value="">Select Service</option>
                          {serviceList.map((s, i) => (
                            <option key={i} value={s.menuUrl}>
                              {s.menuTittle}
                            </option>
                          ))}
                        </select>
                      </div>
                    </div>
                  </div>

                  {/* Dashboard Table */}
                  {selectedService && filterNames.length > 0 && (
                    <div className="row">
                      <div className="col-md-1"></div>
                      <div className="col-md-10">
                        <h3 style={{ fontWeight: "600", marginBottom: "15px" }}>
                          Dashboard List
                        </h3>

                        <table
                          style={{
                            borderCollapse: "collapse",
                            width: "100%",
                            border: "1px solid #dee2e6",
                            backgroundColor: "#fff",
                            fontSize: "14px",
                          }}
                        >
                          <thead>
                            <tr>
                              <th
                                style={{
                                  backgroundColor: "#f8f9fa",
                                  textAlign: "center",
                                  fontWeight: "600",
                                  border: "1px solid #dee2e6",
                                  padding: "6px",
                                }}
                              >
                                Chart Name
                              </th>
                              <th
                                style={{
                                  backgroundColor: "#f8f9fa",
                                  textAlign: "center",
                                  fontWeight: "600",
                                  border: "1px solid #dee2e6",
                                  padding: "6px",
                                }}
                              >
                                Access
                              </th>
                            </tr>
                          </thead>
                          <tbody>
                            {filterNames.map((chartName, index) => (
                              <tr key={index}>
                                <td
                                  style={{
                                    border: "1px solid #dee2e6",
                                    padding: "6px 10px",
                                    textAlign: "left",
                                  }}
                                >
                                  {chartName}
                                </td>
                                <td
                                  style={{
                                    border: "1px solid #dee2e6",
                                    padding: "6px 10px",
                                    textAlign: "center",
                                  }}
                                >
                                  <input
                                    type="checkbox"
                                    checked={checkedState[chartName] || false}
                                    onChange={() =>
                                      setCheckedState((prev) => ({
                                        ...prev,
                                        [chartName]: !prev[chartName],
                                      }))
                                    }
                                  />
                                </td>
                              </tr>
                            ))}
                          </tbody>
                        </table>
                      </div>
                    </div>
                  )}

                  <hr />

                  <div className=" text-right">
                    <button type="submit" className="btn btn-primary">
                      Submit
                    </button>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </section>
      </div>
    </>
  );
};

export default OrganizationWiseDashboardAllocationForm;
